import { HttpErrorResponse, HttpEvent, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { inject, Injector, Signal } from '@angular/core';
import { Observable, from, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { isAuthTokenExperiment } from '@lentau/auth/shared/experiment';
import { isApiGatewayClientUrl } from '@lentau/core/api/gateway';

export function authErrorInterceptor(
  req: HttpRequest<unknown>,
  next: (req: HttpRequest<unknown>) => Observable<HttpEvent<unknown>>
): Observable<HttpEvent<unknown>> {
  const injector: Injector = inject(Injector);
  const isATE: Signal<boolean> = isAuthTokenExperiment();

  return next(req).pipe(
    catchError((err: HttpErrorResponse): Observable<HttpEvent<unknown>> => {
      if (err.status === HttpStatusCode.Forbidden) {
        return isApiGatewayClientUrl(req.url) ? loadAuthErrorHandler(err, injector) : throwError(() => err);
      }

      return isATE() ? loadTokenRefreshHandler(next, req, err, injector) : loadAuthErrorHandler(err, injector);
    })
  );
}

function loadAuthErrorHandler(err: HttpErrorResponse, injector: Injector): Observable<HttpEvent<unknown>> {
  return from(import('./auth-error.handler')).pipe(
    switchMap(
      (m: { authErrorHandler: (err: HttpErrorResponse, injector: Injector) => Observable<HttpEvent<unknown>> }) =>
        m.authErrorHandler(err, injector)
    )
  );
}

function loadTokenRefreshHandler(
  next: (req: HttpRequest<unknown>) => Observable<HttpEvent<unknown>>,
  req: HttpRequest<unknown>,
  err: HttpErrorResponse,
  injector: Injector
): Observable<HttpEvent<unknown>> {
  return from(import('./auth-token-refresh.handler')).pipe(
    switchMap(
      (m: {
        handleAuthTokenRefreshError: (
          next: (req: HttpRequest<unknown>) => Observable<HttpEvent<unknown>>,
          req: HttpRequest<unknown>,
          err: HttpErrorResponse,
          injector: Injector
        ) => Observable<HttpEvent<unknown>>;
      }) => m.handleAuthTokenRefreshError(next, req, err, injector)
    )
  );
}
